<template>
  <svg width="41" height="40" viewBox="0 0 41 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12.2116 30V26.5909H28.8783V30H33.8783V19.7727L32.2116 16.3636H35.5449V14.6591H30.5449L27.2116 11.25H13.8783L10.5449 14.6591H5.54492V16.3636H8.87826L7.21159 19.7727V30H12.2116ZM30.5449 18.0682L27.2116 12.9545H13.8783L10.5449 18.0682H30.5449ZM12.2116 19.7727L13.8783 23.1818H8.87826V19.7727H12.2116ZM32.2116 23.1818H27.2116L28.8783 19.7727H32.2116V23.1818ZM18.8783 19.7727V23.1818H22.2116V19.7727H27.2116L24.7116 24.8864H16.3783L13.8783 19.7727H18.8783Z"
      class="fill-current"
    />
  </svg>
</template>
